import { CALLTRACKING_WARNING } from '../../experiments/calltrackingWarning';
import { NEWBUILDING_WINNER_EXPERIMENT, WEB_3D_TOURS_EXPERIMENT } from '../../selectors/abExperiments';
import { HOUSE_CARD_URL_EXPERIMENT } from '../../utils/experiments/houseCardUrl';

export const AUD_DESKTOP_ACTI127_OFFER_PAGE_CHAT_SUGGESTIONS = 'aud_desktop_acti127_offer_page_chat_suggestions';

export const EXPERIMENTS: string[] = [
  HOUSE_CARD_URL_EXPERIMENT,
  CALLTRACKING_WARNING,
  NEWBUILDING_WINNER_EXPERIMENT,
  AUD_DESKTOP_ACTI127_OFFER_PAGE_CHAT_SUGGESTIONS,
  WEB_3D_TOURS_EXPERIMENT,
];
